export default __webpack_public_path__ + "static/media/resource-image_lwc.74e74686.png";